import WhIllegalArgumentException from "./WhIllegalArgumentException";

class WhEmptyArgumentException extends WhIllegalArgumentException {
    constructor(message) {
        super();
        this.message = message;
    }
}

export default WhEmptyArgumentException


// WEBPACK FOOTER //
// ./src/assets/csui/parameter/WhEmptyArgumentException.js